import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HttpModule } from '@angular/http';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';

import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import {AppGlobal} from './common/app.global';
import {ServiceGlobal} from './common/services/service.global';
import {Global_DB} from './common/core/global_db';
import { DemoFormComponent } from './application/web-components/demo-form/demo-form.component';
import {ToolsService} from './common/services/tools.service';
import {Student_questionnaire_sharedService} from './common/services/student_questionnaire_shared.service';

// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

@NgModule({
  declarations: [
    AppComponent,
    DemoFormComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    FormsModule,
    HttpModule,
    HttpClientModule,
    ModalModule.forRoot(),
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: (createTranslateLoader),
    //     deps: [HttpClient]
    //   }
    // }),
  ],
  providers: [AppGlobal, ServiceGlobal, Global_DB, ToolsService, Student_questionnaire_sharedService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts